export default __webpack_public_path__ + "static/media/trail.5632cf8d.svg";